import * as classNames from "classNames";
import { BaseComponent } from "../../BaseComponent";
import * as React from "react";

export interface ICountdownCircleProps extends React.Props<CountdownCircle> {
    cssWrapper?: string;
    timeLeft: string;
    radius: number;
    strokeWidth: number;

    // number less or equal to 1 indicating progress
    progress: number;
    secondsToShowMessageAheadOfLogout: number;
}

export interface ICountdownCircleState {}

export class CountdownCircle extends BaseComponent<ICountdownCircleProps, ICountdownCircleState> {
    private _pathRef: SVGCircleElement;

    constructor(props: ICountdownCircleProps) {
        super(props);

        this.state = {};
    }

    public render(): JSX.Element {
        const radius = this.props.radius;
        const strokeWidth = this.props.strokeWidth;
        const circleStyle = this.getCircleStyle();
        const svgSize = radius * 2 + strokeWidth;
        const phase = this.props.progress < 1 / 3 ? 1 : this.props.progress < 2 / 3 ? 2 : 3;
        const wrapClassNames = classNames("countdown-circle", "phase-" + phase, this.props.cssWrapper);
        return (
            <div className={wrapClassNames}>
                <svg>
                    <circle className="circle" cx="104" cy="82" r={radius} strokeWidth={strokeWidth} fill="none" />
                    <circle
                        cx="104"
                        cy="82"
                        r={radius}
                        fill="none"
                        style={circleStyle}
                        className="progress"
                        ref={(pathRef: SVGCircleElement) => (this._pathRef = pathRef)}
                    />
                </svg>
                <div className="labels">
                    <div className="time">
                        <span className="count">{this.props.timeLeft}</span>
                    </div>
                </div>
            </div>
        );
    }

    private getCircleStyle(): {
        strokeDashoffset: string;
        strokeWidth: number;
        strokeDasharray: string;
        animation: string;
    } {
        const pathLength = this.getPathLength().toFixed(0);
        const pathProgress = this.getPathProgress();

        return {
            strokeDashoffset: pathProgress,
            strokeWidth: this.props.strokeWidth,
            strokeDasharray: pathLength,
            animation: `countdown ${this.props.secondsToShowMessageAheadOfLogout}s linear infinite forwards`,
        };
    }

    private getPathLength(): number {
        if (!this._pathRef) {
            return 0;
        }

        return 2 * Math.PI * this.props.radius;
    }

    private getPathProgress(): string {
        return (this.getPathLength() * this.props.progress).toFixed(0);
    }
}
